export default __webpack_public_path__ + "static/media/future.c3a0bd29.png";